import { AccordionDetails, AccordionSummary, styled } from '@mui/material';

export const ReviewContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(6),
  justifyContent: 'space-between',
  marginTop: theme.spacing(3),
  overflow: 'hidden',
  height: '100%',
}));

export const WebhookDetails = styled('div')(({ theme }) => ({
  width: '430px',
  overflowY: 'auto',
  overflowX: 'hidden',
  ...theme.styledScrollbar,
}));

export const WebhookPayload = styled('div')(({ theme }) => ({
  width: '430px',
  marginBottom: theme.spacing(3),
}));

export const SignalsAccordionSummary = styled(AccordionSummary)(() => ({
  padding: 0,
  minHeight: 0,

  '& .MuiAccordionSummary-content': {
    margin: 0,

    '&.Mui-expanded': {
      margin: 0,
    },
  },

  '&.Mui-expanded': {
    minHeight: 0,
  },
}));

export const SignalsAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  borderLeft: `1px solid ${theme.palette.grey[300]}`,
  marginTop: theme.spacing(2),
  padding: theme.spacing(0, 0, 0, 2),
  marginBottom: theme.spacing(3),

  ul: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,

    li: {
      marginBottom: theme.spacing(2),
    },
  },
}));
